import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import broadcastMessageToPortals from './broadcast-message-to-portals'

export default async function sendMessageToSidebarWithIds(messageType: string, args: any, subject: string, people: any): Promise<any> {
  try {
    let id = await office.id()

    if (!id && subject && people) {
      id = await office.save()
    }

    const immutableId = await office.immutableId()

    args.id = id
    args.threadId = args.threadId ?? office.mail.conversationId()
    args.threadIndex = args.threadIndex ?? office.mail.conversationIndex()
    args.headerMessageId = args.headerMessageId ?? office.mail.internetMessageId()
    args.immutableId = immutableId

    if (args.threads && args.threads[0].composing) {
      args.threads[0].id = id
      args.threads[0].threadId = args.threadId
      args.threads[0].threadIndex = args.threadIndex
      args.threads[0].headerMessageId = args.headerMessageId
      args.threads[0].immutableId = immutableId
    }
  } catch {
    // don't let error here prevent message send
  } finally {
    broadcastMessageToPortals(messageType, args)
    state.currentItem.initialItemOpenSent = true
  }

  return args
}
